import { render, staticRenderFns } from "./ModalVisualizar.vue?vue&type=template&id=2095d717"
import script from "./ModalVisualizar.vue?vue&type=script&lang=js"
export * from "./ModalVisualizar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports